import {
  BRAND_FILTER_SHORT_NAME,
  BRAND_FILTER_CONFIG,
} from './brand/searchBrandConfig.js'

import {
  PRICE_FILTER_SHORT_NAME,
  PRICE_FILTER_CONFIG,
} from './price/priceFilterConfig'

import {
  SORTBY_FILTER_SHORT_NAME,
  SORTBY_FILTER_CONFIG,
} from './sortby/sortByFilterConfig'

import {
  PAGE_FILTER_SHORT_NAME,
  PAGE_FILTER_CONFIG,
} from './pagination/paginationFilterConfig'

import {
  PAGE_COUNT_FILTER_SHORT_NAME,
  PAGE_COUNT_FILTER_CONFIG,
} from './pagination/pageCountFilterConfig.js'

import {
  STYLE_FILTER_SHORT_NAME,
  STYLE_FILTER_CONFIG,
} from './style/styleFilterConfig'

import {
  YEAR_FILTER_SHORT_NAME,
  YEAR_FILTER_CONFIG,
} from './moreFiltersContainer/yearsFilterConfig'

import {
  ENGINE_FILTER_SHORT_NAME,
  ENGINE_FILTER_CONFIG,
} from './moreFiltersContainer/engineFilterConfig'

import {
  SEAT_FILTER_SHORT_NAME,
  SEAT_FILTER_CONFIG,
} from './moreFiltersContainer/seatFilterConfig'

import {
  NEWLY_LISTED_FILTER_SHORT_NAME,
  NEWLY_LISTED_FILTER_CONFIG,
} from './moreFiltersContainer/newlyListedConfig'

import {
  MAX_DISTANCE_FILTER_SHORT_NAME,
  MIN_DISTANCE_FILTER_SHORT_NAME,
  MAX_DISTANCE_FILTER_CONFIG,
  MIN_DISTANCE_FILTER_CONFIG,
} from './moreFiltersContainer/distanceFilterConfig'

import {
  START_DATE_SHORT_NAME,
  END_DATE_SHORT_NAME,
  START_DATE_FILTER_CONFIG,
  END_DATE_FILTER_CONFIG,
} from './dates/datesFilterConfig'

import {
  INSTANT_BOOKING_SHORT_NAME,
  INSTANT_BOOKING_FILTER_CONFIG,
} from './instantBooking/instantBookingConfig'

import {
  LOCATION_SHORT_NAME,
  LATITUDE_SHORT_NAME,
  LONGITUDE_SHORT_NAME,
  LOCATION_FILTER_CONFIG,
  LATITUDE_FILTER_CONFIG,
  LONGITUDE_FILTER_CONFIG,
} from './location/locationFiltersConfig'

import {
  IS_BIKE_FOR_SALE_FILTER_SHORT_NAME,
  IS_BIKE_FOR_SALE_FILTER_CONFIG,
} from './moreFiltersContainer/isBikeForSaleFilterConfig'

import {
  TWENTY_POINT_INSPECTED_FILTER_SHORT_NAME,
  TWENTY_POINT_INSPECTED_FILTER_CONFIG
} from './moreFiltersContainer/twentyPointInspected.js'

export const SEARCH_FILTERS = {
  [PRICE_FILTER_SHORT_NAME]: PRICE_FILTER_CONFIG,
  [SORTBY_FILTER_SHORT_NAME]: SORTBY_FILTER_CONFIG,
  [BRAND_FILTER_SHORT_NAME]: BRAND_FILTER_CONFIG,
  [PAGE_FILTER_SHORT_NAME]: PAGE_FILTER_CONFIG,
  [PAGE_COUNT_FILTER_SHORT_NAME]: PAGE_COUNT_FILTER_CONFIG,
  [STYLE_FILTER_SHORT_NAME]: STYLE_FILTER_CONFIG,
  [YEAR_FILTER_SHORT_NAME]: YEAR_FILTER_CONFIG,
  [ENGINE_FILTER_SHORT_NAME]: ENGINE_FILTER_CONFIG,
  [SEAT_FILTER_SHORT_NAME]: SEAT_FILTER_CONFIG,
  [MAX_DISTANCE_FILTER_SHORT_NAME]: MAX_DISTANCE_FILTER_CONFIG,
  [MIN_DISTANCE_FILTER_SHORT_NAME]: MIN_DISTANCE_FILTER_CONFIG,
  [START_DATE_SHORT_NAME]: START_DATE_FILTER_CONFIG,
  [END_DATE_SHORT_NAME]: END_DATE_FILTER_CONFIG,
  [INSTANT_BOOKING_SHORT_NAME]: INSTANT_BOOKING_FILTER_CONFIG,
  [LOCATION_SHORT_NAME]: LOCATION_FILTER_CONFIG,
  [LATITUDE_SHORT_NAME]: LATITUDE_FILTER_CONFIG,
  [LONGITUDE_SHORT_NAME]: LONGITUDE_FILTER_CONFIG,
  [NEWLY_LISTED_FILTER_SHORT_NAME]: NEWLY_LISTED_FILTER_CONFIG,
  [TWENTY_POINT_INSPECTED_FILTER_SHORT_NAME]: TWENTY_POINT_INSPECTED_FILTER_CONFIG,
  [IS_BIKE_FOR_SALE_FILTER_SHORT_NAME]: IS_BIKE_FOR_SALE_FILTER_CONFIG,
}

export const SEARCH_FILTER_KEYS = Object.keys(SEARCH_FILTERS)

const buildSearchDefaults = () => {
  let defaults = {}
  for (let i = 0; i < SEARCH_FILTERS.length; i++) {
    defaults[SEARCH_FILTERS[i].short_name] = SEARCH_FILTERS[i].default_values
  }
  return defaults
}

export const searchFilterDefaults = buildSearchDefaults()
